
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/manpower",
      function () {
        return require("private-next-pages/companies/manpower/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/manpower"])
      });
    }
  